// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yTCge{cursor:default;cursor:var(--truncate-text-cursor,default);display:inline-block;max-width:100%;max-width:var(--truncate-text-max-width,100%);overflow:hidden;text-overflow:ellipsis;vertical-align:bottom;white-space:nowrap}.czpCF.ui.popup{max-width:480px;max-width:30rem;overflow-wrap:anywhere}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `yTCge`,
	"popup": `czpCF`
};
module.exports = ___CSS_LOADER_EXPORT___;
